import http from '@/http'
import lms from '@/http/lms'
import findIndex from 'lodash/findIndex'

const enterpriseIDsAllowProfessions = ['9fcd8461-bc62-4897-9cfb-66a0696d7eb7']

export default {
  namespaced: true,
  state: {
    user: {},
    favorites: [],
    achievements: [],
    showInfinityModal: true,
    userLastPaymentMethod: {},
    isCreditCardExpired: false,
    showModalStaagejobs6: true,
    isStaagejobsUser: false,
    showBlackFridayModal2: true,
    showInfinityModalBF: true,
    showInfinityModalBFSale: true,
    showFormationsModal: true,
    canShowModalDMM2k23: true,
    isMixPanelIdentified: false,
    allowProfessions: false
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setFavorites(state, favorites) {
      state.favorites = favorites
    },
    setUpdateLessonProgress(state, objectProgress) {
      const positionFollow = findIndex(state.user.userFollow, { lessonID: objectProgress.lessonID })
      if (positionFollow !== -1) {
        objectProgress.contentFollowCompleted = objectProgress.contentFollowPercentual >= 95
        if (state.user.userFollow[positionFollow].contentFollowCompleted === true) {
          objectProgress.contentFollowCompleted = true
        }
        state.user.userFollow[positionFollow] = objectProgress
      } else {
        state.user.userFollow.push(objectProgress)
      }
    },
    setAchievements(state, achievements) {
      state.achievements = achievements
    },
    setUserLastPaymentMethod(state, userLastPaymentMethod) {
      state.userLastPaymentMethod = userLastPaymentMethod
    },
    setIsCreditCardExpired(state, isCreditCardExpired) {
      state.isCreditCardExpired = isCreditCardExpired
    },
    setShowModalStaagejobs6(state, showModalStaagejobs6) {
      state.showModalStaagejobs6 = showModalStaagejobs6
    },
    setIsStaagejobsUser(state, isStaagejobsUser) {
      state.isStaagejobsUser = isStaagejobsUser
    },
    setShowBlackFridayModal2(state, showBlackFridayModal2) {
      state.showBlackFridayModal2 = showBlackFridayModal2
    },
    setShowInfinityModalBF(state, showInfinityModalBF) {
      state.showInfinityModalBF = showInfinityModalBF
    },
    setShowInfinityModalBFSale(state, showInfinityModalBFSale) {
      state.showInfinityModalBFSale = showInfinityModalBFSale
    },
    setShowFormationsModal(state, showFormationsModal) {
      state.showFormationsModal = showFormationsModal
    },
    setShowModalDMM2k23(state, canShowModalDMM2k23) {
      state.canShowModalDMM2k23 = canShowModalDMM2k23
    },
    setIsMixPanelIdentified(state, isMixPanelIdentified) {
      state.isMixPanelIdentified = isMixPanelIdentified
    },
    setAllowProfessions(state, allowProfessions) {
      state.allowProfessions = allowProfessions
    }
  },
  actions: {
    async userReadMe({ commit, dispatch }) {
      try {
        const response = await http.get('/user/readMe')
        commit('setUser', response.data.data)
        dispatch('validateAllowProfessions', response.data.data.userExtra?.enterpriseID)

        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async favoritesRead({ commit }) {
      try {
        const response = await http.post('/user/favorites/read', { limit: 20 })
        commit('setFavorites', response.data.data)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async favoritesCreate({}, courseID) {
      try {
        const response = await http.post('/user/favorites/create', { courseID: courseID })
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async favoritesDelete({}, courseID) {
      try {
        const response = await http.post('/user/favorites/delete', { courseID: courseID })
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async updateLessonProgress({ commit, state }, props) {
      try {
        await lms.post('content-follow', {
          userID: state.user.userID,
          courseID: props.courseID,
          lessonID: props.lessonID,
          contentFollowPercentual: props.percentual,
          contentFollowMilliSeconds: props.seconds
        })
        const $progressItem = {
          userID: state.user.userID,
          pathID: '',
          courseID: props.courseID,
          lessonID: props.lessonID,
          contentFollowCreatedAt: new Date(),
          contentFollowUpdatedAt: new Date(),
          contentFollowPercentual: props.percentual,
          contentFollowMilliSeconds: props.seconds,
          contentFollowCompleted: props.percentual >= 95
        }
        commit('setUpdateLessonProgress', $progressItem)
        return true
      } catch (err) {
        console.error(err)
      }
    },
    async changePaymentMethod({}, paymentMethod) {
      try {
        const response = await http.post('/user/changePaymentMethod', paymentMethod)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async subscriptionRecurrencyOn({}, userId) {
      try {
        const response = await http.get('user/subscription/subscriptionRecurrencyOn', userId)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    getUserLastPaymentMethod({ commit, getters }) {
      if (getters.userData.hasOwnProperty('userPaymentMethods') && getters.userData.userPaymentMethods.length > 0) {
        const lastPaymentMethod = getters.userData.userPaymentMethods.sort(
          (a, b) => new Date(b.methodLastUsed) - new Date(a.methodLastUsed)
        )[0]
        commit('setUserLastPaymentMethod', lastPaymentMethod)
      }
    },
    checkCreditCardExpired({ commit, getters }) {
      if (getters.userLastPaymentMethod.methodType === 'credit_card') {
        const creditCardDate = getters.userLastPaymentMethod.methodDetails.expiration_date
        let creditCardMonth
        let credtCardYear
        let currentYear

        if (creditCardDate.includes('/')) {
          creditCardMonth = creditCardDate.split('/')[0]
          credtCardYear = creditCardDate.split('/')[1]
          currentYear = new Date().getFullYear().toString()
        } else {
          creditCardMonth = creditCardDate.substring(0, 2)
          credtCardYear = creditCardDate.substring(2, 4)
          currentYear = new Date().getFullYear().toString().slice(-2)
        }

        const currentMonth = new Date().getMonth() + 1
        if (credtCardYear > currentYear) {
          commit('setIsCreditCardExpired', false)
        } else if (credtCardYear === currentYear && creditCardMonth >= currentMonth) {
          commit('setIsCreditCardExpired', false)
        } else {
          commit('setIsCreditCardExpired', true)
        }
      }
    },
    async getAchievements({ commit }) {
      try {
        const response = await lms.get('achievements')
        commit('setAchievements', response.data.data)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async getUserOutputs() {
      try {
        const response = await http.get('user/outputs')
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async getPublicProfile({}, userID) {
      try {
        const response = await http.get(`/user/public-profile/${userID}`)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    updateIsMixPanelIdentified({ commit }, value) {
      commit('setIsMixPanelIdentified', value)
    },
    validateAllowProfessions({ commit }, enterpriseID) {
      commit('setAllowProfessions', enterpriseIDsAllowProfessions.includes(enterpriseID))
    },
    async getUserStreak({}) {
      const respose = await http.post('/user/loginstreak')
      return respose?.data
    }
  },
  getters: {
    userData: (state) => state.user,
    favorites: (state) => state.favorites,
    userFollow: (state) => state.user.userFollow,
    userLastPaymentMethod: (state) => state.userLastPaymentMethod,
    isCreditCardExpired: (state) => state.isCreditCardExpired,
    getCourseFollow: (state) => (_courseID) => {
      return (state.user.userFollow || []).filter((item) => item.courseID === _courseID)
    },
    getLessonFollow: (state) => (_lessonID) => {
      return (state.user.userFollow || [])
        .sort((a, b) => new Date(b.contentFollowUpdatedAt) - new Date(a.contentFollowUpdatedAt))
        .find((item) => item.lessonID === _lessonID)
    },
    achievements: (state) => state.achievements,
    showInfinityModalBF: (state) => {
      return state.showInfinityModalBF
    },
    showInfinityModalBFSale: (state) => {
      return state.showInfinityModalBFSale
    },
    showFormationsModal: (state) => {
      return state.showFormationsModal
    },
    isFounder: (state) => {
      return state.achievements?.filter((achievement) => achievement.achievementTitle === 'Founder')
    },
    isInfinity: (state) => {
      return state.achievements?.filter((achievement) => achievement.achievementTitle === 'Vitalício')
    },
    externalSaleIsSuccesfull: (state) => {
      return state.externalSaleIsSuccesfull
    },
    showModalStaagejobs6: (state) => state.showModalStaagejobs6,
    isStaagejobsUser: (state) => state.isStaagejobsUser,
    showBlackFridayModal2: (state) => state.showBlackFridayModal2,
    canShowModalDMM2k23: (state) => state.canShowModalDMM2k23,
    isMixPanelIdentified: (state) => state.isMixPanelIdentified,
    allowProfessions: (state) => state.allowProfessions
  }
}
